module.exports = __webpack_public_path__ + "static/media/11.53ac75b1.png";